import { enUS, ptBR, type Locale } from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import ptBRLocale from '../locales/pt-BR.json';

export type SupportedLanguage = 'en' | 'pt-BR';

export const SUPPORTED_LANGUAGES: ReadonlyArray<{
  code: SupportedLanguage;
  flag: string;
  label: string;
}> = [
  { code: 'en', flag: '🇺🇸', label: 'English' },
  { code: 'pt-BR', flag: '🇧🇷', label: 'Português' },
];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'pt-BR': { translation: ptBRLocale },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'pt-BR'],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'gopinhos.lang',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

const DATE_LOCALES: Record<SupportedLanguage, Locale> = {
  en: enUS,
  'pt-BR': ptBR,
};

export function dateLocaleFor(lang: string): Locale {
  return DATE_LOCALES[(lang as SupportedLanguage) in DATE_LOCALES ? (lang as SupportedLanguage) : 'en'];
}

export default i18n;
